module.exports = __webpack_public_path__ + "static/media/wire2.f63f4de7.png";